// src/components/kiosk/EmployeeProfile.jsx
import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const EmployeeProfile = ({ 
  employee,
  className = ''
}) => {
  const {
    name = 'Mitarbeitername',
    employeeId = 'EMP001',
    photo = null,
    department = 'Allgemein'
  } = employee || {};

  return (
    <div className={`flex flex-col items-center space-y-4 ${className}`}>
      {/* Employee Photo */}
      <div className="relative">
        <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-primary elevation-2">
          {photo ? (
            <Image
              src={photo}
              alt={`${name} profile photo`}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full bg-muted flex items-center justify-center">
              <Icon 
                name="User" 
                size={48} 
                className="text-text-secondary"
              />
            </div>
          )}
        </div>
        
        {/* Status Indicator */}
        <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-success rounded-full border-4 border-background flex items-center justify-center">
          <Icon 
            name="Check" 
            size={16} 
            color="white"
          />
        </div>
      </div>

      {/* Employee Information */}
      <div className="text-center space-y-2">
        <h3 className="text-2xl font-semibold text-text-primary">
          {name}
        </h3>
        <div className="space-y-1">
          <p className="text-lg text-text-secondary">
            ID: {employeeId}
          </p>
          <p className="text-base text-text-secondary">
            {department}
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmployeeProfile;